import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button, Typography } from '@quikr/ui';
import config from '../../../../../config';
const { IMAGE_CDN_DOMAIN } = config;

const Wrapper = styled.div`
  height: 135px;
  border-radius: 4px;
  color: ${({ theme }) => theme.colors.Neutral[600]};
  background: url('${IMAGE_CDN_DOMAIN}/core/clsfd/assets/map.jpeg') no-repeat center;
  background-size: cover;
  @media screen and (max-width: 767px) {
    height: 145px;
  }
`;

const InnerWrapper = styled.div`
  height: 50px;
  padding: 0 16px;
  background: rgba(0, 0, 0, 0.6);
  @media screen and (max-width: 767px) {
    padding: 0 12px;
  }
`;

const Locality = styled(Typography)`
  width: calc(100% - 120px);
`;

const ButtonSubmit = styled(Button)`
  padding: 7px 12px;
  border-color: #fff;
  color: #fff;
`;

const handleClick = (coordinates) => {
  const { latitude, longitude } = coordinates;
  window.open('https://www.google.com/maps/place/' + latitude + ',' + longitude, '_blank');
};

const Location = (props) => {
  const { coordinates, title } = props;
  return (
    <Wrapper className="pR oH">
      <InnerWrapper className="pA dFA jcSB w100 b0">
        <Locality tagName="span" modifiers="bt2" className="Ell fwB" title={title}>
          {title}
        </Locality>
        <ButtonSubmit
          className="hA bt2"
          onClick={(e) => handleClick(coordinates)}
          btnType="secondary"
        >
          Explore Now
        </ButtonSubmit>
      </InnerWrapper>
    </Wrapper>
  );
};

Location.propTypes = {
  coordinates: PropTypes.object,
  title: PropTypes.string
};

export default Location;
